import React, { Component } from 'react';
import api from './../../utilites/api';
import ListEnderecos from './../../fragments/listEndereco';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Skeleton from '@material-ui/lab/Skeleton';



export default class Endereco extends Component {

  state = {
    enderecos: [],
    colorHeader: "#991e25",
    idUser: '',
    isLoading: false,
    endPadrao: ''

  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    this.setState({
      endPadrao: localStorage.getItem('@webApp/enderecoId'),
    });

    if (localStorage.getItem('@webApp/userid') !== null) {
      console.log('fdsfd')
      this.setState({ idUser: localStorage.getItem('@webApp/userid') });
      this.getServidor();
    }
  }

  async getServidor() {
    try {
      const data = new FormData();
      data.append('id_user', localStorage.getItem('@webApp/userid'));

      const response = await api.post('ws/ListEndereco.php', data);
      console.log("resposta ", response.data)
      if (response.status === 200) {
        this.setState({
          enderecos: response.data
        });

      } else {
        alert('Erro na comunicação com  servidor!', 'Atenção', false);
      }

    } catch (error) {
      console.log('Erro ', error)
      alert('Erro na comunicação com servidor!', 'Atenção', false);
    }

    this.setState({ isLoading: false });
  }

  async Excluir(id) {
    try {
      const data = new FormData();
      data.append('id', id);

      const response = await api.post('ws/Ex_Endereco.php', data);
      console.log("resposta ", response.data)
      if (response.status === 200) {

      } else {
        alert('Erro na comunicação com  servidor!', 'Atenção', false);
      }

    } catch (error) {
      console.log('Erro ', error)
      alert('Erro na comunicação com servidor!', 'Atenção', false);
    }

    this.getServidor()
  }

  async preecherTab(i) {
    localStorage.setItem('@webApp/enderecoNome', i.Nome);
    localStorage.setItem('@webApp/enderecoEnd', i.Rua);
    localStorage.setItem('@webApp/enderecoBairro', i.Bairro);
    localStorage.setItem('@webApp/enderecoValor', i.Valor);
    localStorage.setItem('@webApp/enderecoNumero', i.Numero);
    localStorage.setItem('@webApp/enderecoId', i.id);

    this.props.history.goBack()
  }

  form() {
    return (
      <div style={{ 
        minHeight: '100vh', 
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        {this.header()}
        
        {/* Container Principal */}
        <div style={{ 
          maxWidth: '800px', 
          margin: '0 auto', 
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          {this.state.enderecos.length > 0 ? (
            <>
              {/* Título da seção */}
              <div style={{
                background: 'linear-gradient(135deg, #fff, #f8f9fa)',
                borderRadius: '12px',
                padding: '16px 20px',
                boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
                border: '1px solid rgba(0,0,0,0.04)'
              }}>
                <h3 style={{
                  margin: 0,
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#333',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  📍 Meus Endereços Salvos
                </h3>
                <p style={{
                  margin: '8px 0 0 0',
                  fontSize: '14px',
                  color: '#666'
                }}>
                  Selecione um endereço ou adicione um novo
                </p>
              </div>

              {/* Lista de endereços */}
              {this.state.enderecos.map((endereco, index) => (
                <div key={endereco.id} style={{
                  background: '#fff',
                  borderRadius: '16px',
                  padding: '20px',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
                  border: this.state.endPadrao === endereco.id ? '2px solid #991e25' : '1px solid rgba(0,0,0,0.04)',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  position: 'relative'
                }}
                onMouseEnter={(e) => {
                  if (this.state.endPadrao !== endereco.id) {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (this.state.endPadrao !== endereco.id) {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 16px rgba(0,0,0,0.06)';
                  }
                }}
                onClick={() => this.preecherTab(endereco)}
                >
                  {/* Badge de endereço padrão */}
                  {this.state.endPadrao === endereco.id && (
                    <div style={{
                      position: 'absolute',
                      top: '-8px',
                      right: '16px',
                      background: 'linear-gradient(135deg, #991e25, #b52d36)',
                      color: '#fff',
                      padding: '4px 12px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      fontWeight: '600',
                      boxShadow: '0 2px 8px rgba(153, 30, 37, 0.3)'
                    }}>
                      ⭐ Padrão
                    </div>
                  )}

                  {/* Cabeçalho do endereço */}
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    marginBottom: '12px'
                  }}>
                    <h4 style={{
                      margin: 0,
                      fontSize: '18px',
                      fontWeight: '700',
                      color: '#991e25',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      🏠 {endereco.Nome}
                    </h4>
                    
                    {/* Botão de excluir */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (window.confirm('Tem certeza que deseja excluir este endereço?')) {
                          this.setState({ isLoading: true });
                          localStorage.setItem('@webApp/enderecoNome', null);
                          localStorage.setItem('@webApp/enderecoEnd', null);
                          localStorage.setItem('@webApp/enderecoBairro', null);
                          localStorage.setItem('@webApp/enderecoValor', null);
                          localStorage.setItem('@webApp/enderecoNumero', null);
                          localStorage.setItem('@webApp/enderecoId', null);
                          this.Excluir(endereco.id);
                        }
                      }}
                      style={{
                        background: 'linear-gradient(135deg, #dc3545, #c82333)',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '6px 8px',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: '600',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                      onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                    >
                      🗑️ Excluir
                    </button>
                  </div>

                  {/* Informações detalhadas do endereço */}
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      fontSize: '14px',
                      color: '#555'
                    }}>
                      <span style={{ fontWeight: '600' }}>📍 Endereço:</span>
                      <span>{endereco.Rua}, {endereco.Numero}</span>
                    </div>
                    
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      fontSize: '14px',
                      color: '#555'
                    }}>
                      <span style={{ fontWeight: '600' }}>🏘️ Bairro:</span>
                      <span>{endereco.Bairro}</span>
                    </div>

                    {endereco.Complemento && (
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontSize: '14px',
                        color: '#555'
                      }}>
                        <span style={{ fontWeight: '600' }}>📝 Complemento:</span>
                        <span>{endereco.Complemento}</span>
                      </div>
                    )}

                    {endereco.Valor && parseFloat(endereco.Valor) > 0 && (
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontSize: '14px',
                        color: '#991e25',
                        fontWeight: '600',
                        marginTop: '4px'
                      }}>
                        <span>🚚 Taxa de entrega:</span>
                        <span>R$ {this.mascaraValor(eval(parseFloat(endereco.Valor)).toFixed(2))}</span>
                      </div>
                    )}
                  </div>

                  {/* Indicador de seleção */}
                  <div style={{
                    marginTop: '12px',
                    padding: '8px 12px',
                    background: this.state.endPadrao === endereco.id 
                      ? 'linear-gradient(135deg, #e8f5e8, #d4edda)' 
                      : 'linear-gradient(135deg, #f8f9fa, #e9ecef)',
                    borderRadius: '8px',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: this.state.endPadrao === endereco.id ? '#155724' : '#6c757d',
                    textAlign: 'center'
                  }}>
                    {this.state.endPadrao === endereco.id 
                      ? '✅ Endereço selecionado' 
                      : '👆 Clique para selecionar este endereço'}
                  </div>
                </div>
              ))}
            </>
          ) : (
            /* Estado vazio */
            <div style={{
              background: '#fff',
              borderRadius: '16px',
              padding: '40px 20px',
              textAlign: 'center',
              boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
              border: '1px solid rgba(0,0,0,0.04)'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📍</div>
              <h3 style={{ margin: '0 0 8px 0', color: '#333' }}>Nenhum endereço cadastrado</h3>
              <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                Adicione seu primeiro endereço para continuar
              </p>
            </div>
          )}
        </div>

        {/* Botão de novo endereço */}
        <div style={{ 
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          right: '20px',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          <Button 
            variant="contained" 
            style={{
              width: '100%',
              height: '56px',
              borderRadius: '16px',
              background: 'linear-gradient(135deg, #28a745, #20c997)',
              boxShadow: '0 8px 24px rgba(40, 167, 69, 0.3)',
              fontSize: '16px',
              fontWeight: '700',
              textTransform: 'none',
              border: 'none',
              color: '#fff'
            }}
            onClick={() => {
              this.props.history.push({
                pathname: '/CadEndereco',
                state: { quemChamou: 'List' }
              })
            }}
          >
            🏠 Adicionar Novo Endereço
          </Button>
        </div>
      </div>
    );
  }

  enderecoS() {
    return (
      <div>
        <Skeleton variant="rect" height={50} style={{ marginBottom: 15 }} />
        <Skeleton variant="rect" height={50} style={{ marginBottom: 15 }} />
        <Skeleton variant="rect" height={50} style={{ marginBottom: 15 }} />
        <Skeleton variant="rect" height={50} style={{ marginBottom: 15 }} />
        <Skeleton variant="rect" height={50} style={{ marginBottom: 15 }} />
      </div>
    );
  }

  header() {
    return (
      <header style={{ 
        background: 'linear-gradient(135deg, #991e25 0%, #b52d36 100%)',
        padding: '16px 20px',
        boxShadow: '0 4px 20px rgba(153, 30, 37, 0.3)',
        borderBottom: '3px solid rgba(255,255,255,0.1)',
        position: 'sticky',
        top: 0,
        zIndex: 1000
      }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          <button 
            onClick={() => this.props.history.goBack()}
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              borderRadius: '12px',
              padding: '8px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s ease',
              backdropFilter: 'blur(10px)'
            }}
            onMouseEnter={(e) => e.target.style.background = 'rgba(255,255,255,0.25)'}
            onMouseLeave={(e) => e.target.style.background = 'rgba(255,255,255,0.15)'}
          >
            <ArrowBackIcon style={{ color: '#fff', fontSize: 24 }} />
          </button>
          
          <div style={{ marginLeft: 16 }}>
            <h1 style={{ 
              fontSize: 28, 
              fontWeight: 800, 
              margin: 0, 
              color: '#fff',
              letterSpacing: '0.5px',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}>
              📍 Meus Endereços
            </h1>
            <p style={{
              margin: 0,
              fontSize: '14px',
              color: 'rgba(255,255,255,0.8)',
              fontWeight: '500'
            }}>
              Gerencie seus endereços de entrega
            </p>
          </div>
        </div>
      </header>
    );
  }

  render() {
    return this.state.isLoading ? this.enderecoS() : this.form();
  }

  mascaraValor(valor) {
    valor = valor.toString().replace(/\D/g, "");
    valor = valor.toString().replace(/(\d)(\d{8})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{5})$/, "$1.$2");
    valor = valor.toString().replace(/(\d)(\d{2})$/, "$1,$2");
    return valor;
  }
}